import { Link } from "react-router-dom";
import { videos, featuredVideos } from "@/mocks/videos";
import { sortVideos, formatPlayCount } from "@/utils/video";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import SectionHeading from "@/components/base/SectionHeading";
import VideoCard from "@/components/base/VideoCard";

export default function Home() {
  const slides = featuredVideos
    .map((id) => videos.find((item) => item.id === id))
    .filter((item): item is (typeof videos)[number] => Boolean(item))
    .map((item) => ({
      id: item.id,
      title: item.title,
      cover: item.cover,
      categoryName: item.categoryName,
      description: item.description,
      playCount: item.playCount,
    }));

  const latestVideos = sortVideos(videos, "latest").slice(0, 8);
  const popularVideos = sortVideos(videos, "play").slice(0, 8);
  const spotlight = popularVideos[0];

  return (
    <div className="w-full">
      <section className="mx-auto w-full max-w-[1400px] px-4 pt-6 md:px-6">
        <HeroCarousel slides={slides} />
      </section>

      <section className="mx-auto w-full max-w-[1400px] px-4 pt-12 md:px-6">
        <SectionHeading title="视频分类" subtitle="按类别快速进入，找到你想看的内容" />
        <CategoryGrid />
      </section>

      <section className="mx-auto w-full max-w-[1400px] px-4 pt-12 md:px-6">
        <SectionHeading
          title="最新视频"
          subtitle="按发布时间排序，刚刚上新的精彩内容"
          moreTo="/category/movie"
          moreLabel="浏览更多"
        />
        <div className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2 lg:grid-cols-4">
          {latestVideos.map((video, index) => (
            <VideoCard key={video.id} video={video} index={index} />
          ))}
        </div>
      </section>

      <section className="mt-12 bg-background-100 py-12">
        <div className="mx-auto w-full max-w-[1400px] px-4 md:px-6">
          <SectionHeading title="热门视频" subtitle="根据播放量与推荐值精选，大家都在看" />
          <div className="grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2 lg:grid-cols-4">
            {popularVideos.map((video, index) => (
              <VideoCard key={video.id} video={video} index={index} />
            ))}
          </div>
        </div>
      </section>

      {spotlight && (
        <section className="mx-auto w-full max-w-[1400px] px-4 pt-12 md:px-6">
          <div className="grid grid-cols-1 items-center gap-6 overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:grid-cols-2">
            <div className="order-2 p-6 md:p-10 lg:order-1">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
                <i className="ri-fire-fill" aria-hidden="true"></i>
                本周之星
              </span>
              <h2 className="mt-4 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
                {spotlight.title}
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                {spotlight.description}
              </p>
              <div className="mt-4 flex flex-wrap items-center gap-4 text-sm text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-play-circle-line text-base text-primary-500" aria-hidden="true"></i>
                  {formatPlayCount(spotlight.playCount)} 次播放
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-star-fill text-base text-accent-500" aria-hidden="true"></i>
                  评分 {spotlight.score.toFixed(1)}
                </span>
              </div>
              <Link
                to={`/detail/${spotlight.id}`}
                className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-play-fill text-lg" aria-hidden="true"></i>
                观看详情
              </Link>
            </div>
            <div className="order-1 aspect-video w-full lg:order-2 lg:aspect-auto lg:h-full">
              <img
                src={spotlight.cover}
                alt={`${spotlight.title} 推荐封面`}
                title={`${spotlight.title} - 色色视频`}
                className="h-full w-full object-top"
              />
            </div>
          </div>
        </section>
      )}
    </div>
  );
}